import * as types from './featureAccess.actionTypes';
import { createAsyncAction, createAction } from 'typesafe-actions';
import { enums } from '@nimbly-technologies/nimbly-common';
import { FeaturesTypes } from 'reducers/featureAccess/type';

export const setPackageType = createAction(types.SET_PACKAGE_TYPE)<{ packageType: enums.Package }>();
export const dismissFeatureModal = createAction(types.DISMISS_FEATURE_MODAL)();
export const showFeatureModal = createAction(types.SHOW_FEATURE_MODAL)();
export const setOrganization = createAction(types.SET_ORG)<{ org: string }>();
export const resetFeatureAccess = createAction(types.RESET_FEATURE_ACCESS)();

export const fetchFeatureAccess = createAsyncAction(
	types.FETCH_FEATURE_ACCESS_REQUEST,
	types.FETCH_FEATURE_ACCESS_SUCCESS,
	types.FETCH_FEATURE_ACCESS_FAILURE,
)<undefined, { data: FeaturesTypes; packageType: enums.Package }, { error: string }>();
